module.exports = __webpack_public_path__ + "media/images/npr-64a19a351adc4564e4e90cbef65439ccfd9725e61427968df694f3f821e836a9.png";